import { useGet } from 'restful-react'
import { GetProfilesResponse } from './interfaces'

const useGetProfiles = () => {
    return useGet<GetProfilesResponse>('/user/profile')
}

export default useGetProfiles
